import { useState, useEffect, useMemo } from 'react';
import { isEmmaVersionAtLeast } from '../helpers/common';

export const useEmmaVersionCheck = ({ minVersion }: { minVersion: string }) => {
  const [currentVersion, setCurrentVersion] = useState<string>(null);

  useEffect(() => {
    import('@axa-asia/hk-emma-js').then((mod) => {
      mod.EmmaFactory.createInstance().then((p) => {
        setCurrentVersion(p.env.version);
      });
    });
  }, [setCurrentVersion]);

  return useMemo(
    () =>
      isEmmaVersionAtLeast({
        currentVersion,
        minVersion,
      }),
    [currentVersion, minVersion],
  );
};
